import React, { Component } from 'react';
import { translate } from 'react-i18next';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import { Icon } from 'react-icons-kit';
import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more';
import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right';

import Button from 'components/Button/Button';
import CustomModal from 'components/CustomModal/CustomModal';
import Utils from 'utils/Utils';

import './TreeIndex.css';

class TreeIndex extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      allData: this.props.data,
      searched: false,
      opened: false,
      sizeFontTitle: 26,
      sizeFontSubtitle: 16,
      sizeFontContent: 14,
      sizeFontTree: 14
    };
  }

  componentDidMount(){
    const elements = [ ...document.querySelectorAll('.MuiTreeItem-root')];
    elements.forEach((e) => e.addEventListener('keydown', ({keyCode, target}) => {
      if(keyCode === 13) {target.querySelector('.MuiTypography-root').click()}
    }));
  }

  onClickTreeItem = (node, evt) => {
    evt.preventDefault();
    this.props.changeSelected(node);

    setTimeout(() => {
      if(document.querySelector('[tabindex="1"]')) {
        document.querySelector('[tabindex="1"]').focus();
        // document.querySelector(`#${node.id}`).click();
      }
    }, 100);
  }

  searchContents = () => {
    const query = document.getElementById('iberpix-help-input').value.trim();
    if (query.length >= 3) {
      const newData = [];
      this.state.data.forEach((item) => {
        const newItem = JSON.parse(JSON.stringify(item));
        delete newItem.children;
        if (Utils.stringContainsString(newItem.title, query) || Utils.stringContainsString(newItem.subtitle, query) || Utils.stringContainsString(newItem.content, query)) {
          newData.push(newItem);
        }

        if (item.hasOwnProperty('children') && item.children.length > 0) {
          item.children.forEach((child) => {
            const newChild = JSON.parse(JSON.stringify(child));
            delete newChild.children;
            if (Utils.stringContainsString(newChild.title, query) || Utils.stringContainsString(newChild.subtitle, query) || Utils.stringContainsString(newChild.content, query)) {
              newData.push(newChild);
            }

            if (child.hasOwnProperty('children') && child.children.length > 0) {
              child.children.forEach((grandChild) => {
                const newGrandChild = JSON.parse(JSON.stringify(grandChild));
                delete newGrandChild.children;
                if (Utils.stringContainsString(newGrandChild.title, query) || Utils.stringContainsString(newGrandChild.subtitle, query) || Utils.stringContainsString(newGrandChild.content, query)) {
                  newData.push(newGrandChild);
                }
              });
            }
          });
        }
      });

      this.setState({ data: newData, searched: true });
    } else if (query.length === 0) {
      this.clear();
    } else {
      this.setState({ opened: true });
    }
  }

  clear = () => {
    this.setState({ data: this.state.allData, searched: false });
  }

  closeModal = () => {
    this.setState({ opened: false });
  }

  fontSize = (e) => {
    const { sizeFontSubtitle, sizeFontContent, sizeFontTitle, sizeFontTree } = this.state;
    const sizeTit = e.currentTarget.id === 'increaseFont' ? sizeFontTitle + 4 : sizeFontTitle - 4;
    const sizeSub = e.currentTarget.id === 'increaseFont' ? sizeFontSubtitle + 4 : sizeFontSubtitle - 4;
    const sizeCont = e.currentTarget.id === 'increaseFont' ? sizeFontContent + 4 : sizeFontContent - 4;
    const sizeTree = e.currentTarget.id === 'increaseFont' ? sizeFontTree + 4 : sizeFontTree - 4;

    document.getElementsByClassName('ic-title')[0].style.fontSize = `${sizeTit}px`;
    document.getElementsByClassName('ic-subtitle')[0].style.fontSize = `${sizeSub}px`;
    document.getElementsByClassName('ic-content')[0].style.fontSize = `${sizeCont}px`;
    Array.from(document.getElementsByClassName('MuiTreeItem-label')).forEach((elm) => {
      elm.style.fontSize = `${sizeTree}px`;
    })
    this.setState({ ...this.state, sizeFontSubtitle: sizeSub, sizeFontContent: sizeCont, sizeFontTitle: sizeTit, sizeFontTree: sizeTree });
  }

  render() {
    const { t } = this.props;
    const { data, searched, opened } = this.state;
    const allIds = [];
    const treeItems = [];
    data.forEach((elem) => {
      allIds.push(elem.id);
      if (elem.children !== undefined && elem.children.length > 0) {
        const innerItems = [];
        elem.children.forEach((child) => {
          allIds.push(child.id);
          if (child.children !== undefined && child.children.length > 0) {
            const innerInnerItems = [];
            child.children.forEach((grandchild) => {
              allIds.push(grandchild.id);
              innerInnerItems.push(<TreeItem tabIndex="2" key={grandchild.id} nodeId={grandchild.id} label={grandchild.title} onLabelClick={this.onClickTreeItem.bind(null, grandchild)} />);
            });

            innerItems.push(
              <TreeItem tabIndex="2" key={child.id} nodeId={child.id} label={child.title} onLabelClick={this.onClickTreeItem.bind(null, child)}>
                {innerInnerItems}
              </TreeItem>
            );
          } else {
            innerItems.push(<TreeItem tabIndex="2" key={child.id} nodeId={child.id} label={child.title} onLabelClick={this.onClickTreeItem.bind(null, child)} />);
          }
        });

        treeItems.push(
          <TreeItem key={elem.id} tabIndex="2"  nodeId={elem.id} label={elem.title} onLabelClick={this.onClickTreeItem.bind(null, elem)}>
            {innerItems}
          </TreeItem>
        );
      } else {
        treeItems.push(<TreeItem tabIndex="2" key={elem.id} nodeId={elem.id} label={elem.title} onLabelClick={this.onClickTreeItem.bind(null, elem)} />);
      }
    });


    return (
      <div className='index-container'>
        <div className='search-container row'>
          <input type="text" placeholder={t('tree.type_here')} id='iberpix-help-input' />
          <div className='buttonsContainer'>
            <Button className={'btnSearch'} text={t('tree.search')} active={true} onClick={this.searchContents} />
            {searched ?
              <Button text={t('tree.clear')} active={true} onClick={this.clear} />
              : null}
            <Button className={'sizeFonts'} id='increaseFont' text={'A+'} active={true} onClick={this.fontSize} />
            <Button className={'sizeFonts'} id='reduceFont' text={'A-'} active={true} onClick={this.fontSize} />
          </div>
        </div>
        <div className='tree-container'>
          <TreeView defaultExpanded={allIds} defaultCollapseIcon={<Icon size={'18px'} icon={ic_expand_more} />} defaultExpandIcon={<Icon size={'18px'} icon={ic_chevron_right} />}>
            {treeItems}
          </TreeView>
        </div>
        <CustomModal open={opened} blocking={false} onClose={this.closeModal}>
          <div className='block-loader-container'>
            {t('tree.please_characters')}
          </div>
        </CustomModal>
      </div>
    );
  }
}

export default translate()(TreeIndex);
